import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('bills.routes.index'),
        name: 'bills',
        child: false,
        component: () =>
            import(/* webpackChunkName: "bills" */ '@/views/bills/Index.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('bills.breadcrumbs.index'),
                    to: { name: 'bills' },
                    disable: true,
                },
            ],
            billable: true,
            showName: i18n.t('bills.breadcrumbs.index'),
        },
    },
    {
        path: '/' + i18n.t('bills.routes.edit') + '/:id',
        name: 'bill.show',
        child: true,
        component: () =>
            import(/* webpackChunkName: "bills" */ '@/views/bills/Show.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('bills.breadcrumbs.index'),
                    to: { name: 'bills' },
                    disable: true,
                },
                {
                    text: i18n.t('address.breadcrumbs.edit'),
                    to: { name: 'bill.show' },
                    disable: true,
                },
            ],
            billable: true,
        },
        props: true,
    },
]
